import React from 'react';
import styles from './settings-ui.module.css';

export interface SettingsSectionProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
}

/**
 * SettingsSection - Flat section container for settings pages
 * 
 * Linear-inspired design with no card styling, simple bottom border separation
 */
export const SettingsSection: React.FC<SettingsSectionProps> = ({
  title,
  description,
  children,
  className,
}) => {
  return (
    <section className={`${styles.section} ${className || ''}`}>
      <h3 className={styles.sectionTitle}>{title}</h3>
      {description && <p className={styles.sectionDescription}>{description}</p>}
      {children}
    </section>
  );
};

export default SettingsSection;
